import React from 'react'
import Typography from '@material-ui/core/Typography'

const Copy = ({ children, mb = false }) => (
	<Typography paragraph={mb} variant={'subtitle1'}>
		{children}
	</Typography>
)

export default Copy
